import * as types from './types';
import { has } from 'lodash';

const INITIAL_STATE = {
  loading: false,
  error: null,
  sites: [],
  success: false,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.UPDATE_CEP_COUNTS_LOADING:
      return { ...state, loading: payload };
    case types.UPDATE_CEP_COUNTS_ERRORS:
      if (has(payload, 'response.data.Errors')) {
        const error = payload.response.data.Errors[0];
        return {
          ...state,
          error,
        };
      }

      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message:
            'An error occurred while retrieving CEP Update Counts data. Please try again',
        },
      };
    case types.UPDATE_CEP_COUNTS_GET_SITES:
      const filteredSites = payload.filter(
        site =>
          site.AlternateProvisionTypeId === 3 &&
          site.IsLicensed === true &&
          site.IsActive === true
      );
      return {
        ...state,
        sites: filteredSites,
      };
    case types.UPDATE_CEP_COUNTS_CLEAR_ERRORS:
      return {
        ...state,
        error: payload,
      };
    case types.UPDATE_CEP_COUNTS_UPDATE_SUCCESS:
      return { ...state, success: payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/updatecepcounts/state/update/reducer.js